import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Button, Form, Modal, Spinner } from "react-bootstrap";
import authService from "../../../utils/authService";
import { fetchAllCourses } from "../../../utils/courseUtils";
import { fetchBatchesByCourse } from "../../../utils/batchUtils";

interface Course {
  course_id: string;
  course_name: string;
}

interface Batch {
  batch_id: string;
  batch_name: string;
}

const AssignBatch: React.FC = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState<Course[]>([]);
  const [batches, setBatches] = useState<Batch[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<Course | null>(null);
  const [selectedBatch, setSelectedBatch] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [modalNewMessage, setModalNewMessage] = useState<string>("");
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const data = await fetchAllCourses();
      setCourses(data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const handleCourseChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const courseId = e.target.value;
    const selected = courses.find((c) => c.course_id === courseId) || null;
    setSelectedCourse(selected);
    setSelectedBatch("");
    setError("");
    
    if (selected) {
      try {
        const data = await fetchBatchesByCourse(courseId);
        setBatches(data);
      } catch (error) {
        console.error("Error fetching batches:", error);
        setBatches([]);
      }
    } else {
      setBatches([]);
    }
  };

  const handleBatchChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedBatch(e.target.value);
    setError("");
  };

  const handleSubmit = async () => {
    if (!selectedCourse || !selectedBatch) return;
  
    try {
      const weekendGetUrl = `admin/batch/get_weekend_settings/${selectedBatch}/`;
      const weekendRes = await authService.get(weekendGetUrl);
  
      if (weekendRes.data.status !== "ok") {
        // alert("Database error: Failed to fetch weekend settings.");
        setModalNewMessage("Database error: Failed to fetch weekend settings.");
        setShowUpdateModal(true);
        return;
      }
  
      const { saturday, sunday } = weekendRes.data;
      const blobCheckUrl = `admin/batch/is_batch_in_blob/${selectedCourse.course_id}/${selectedBatch}/`;
      const blobRes = await authService.get(blobCheckUrl);
  
      if (!blobRes.data.exists) {
        setModalNewMessage("No day-wise plan found. Please create it first.");
        setShowUpdateModal(true);

        return;
      }
  
      navigate("/admin/edit-day-wise", {
        state: {
          course_id: selectedCourse.course_id,
          batch_id: selectedBatch,
          saturdayStudyDay: saturday ? "Yes" : "No",
          sundayHoliday: sunday ? "Yes" : "No",
        },
      });
    } catch (err) {
      console.error("Error during submission:", err);
      // alert("An unexpected error occurred. Please try again.");
      setModalNewMessage("An unexpected error occurred. Please try again.");
      setShowUpdateModal(true);

    }
  };
  

  return (
    <div  className="border rounded-2 p-5 mt-3 bg-white my-2 me-2"
    style={{ height: `calc(100vh - 110px)`, overflowY: "auto" }} >
      <h4 className="text-center mb-4">Assign Batch</h4>

      <div className="mb-3">
        <label>Select Course:</label>
        <select
          className="form-select"
          value={selectedCourse?.course_id || ""}
          onChange={handleCourseChange}
        >
          <option value="">Select Course</option>
          {courses.map((course) => (
            <option key={course.course_id} value={course.course_id}>
              {course.course_name}
            </option>
          ))}
        </select>
      </div>

      {selectedCourse && (
        <div className="mb-3">
          <label>Select Batch:</label>
          <select
            className="form-select"
            value={selectedBatch}
            onChange={handleBatchChange}
          >
            <option value="">Select Batch</option>
            {batches.map((batch: Batch) => (
              <option key={batch.batch_id} value={batch.batch_id}>
                {batch.batch_name}
              </option>
            ))}
          </select>
        </div>
      )}

      {selectedBatch && (
        <>
          <button
            className="btn btn-success"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </>
      )}

      {error && <p className="text-danger text-center mt-3">{error}</p>}
      <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Message</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalNewMessage}</Modal.Body>
            </Modal>
    </div>
  );
};

export default AssignBatch;
